/**
 * Vrinda Privilege — self-contained cart-layer script
 * Reads config from #vrinda-store-config, manages gift add/remove/swap,
 * overrides subtotals (drawer/page/shipping), patches gift lines,
 * wraps Fastrr/Shiprocket checkout to enforce guard.
 * Does NOT modify vrinda-v2.js.
 */
(function () {
  'use strict';

  /* ── Config ─────────────────────────────────────────────────── */
  var cfgEl = document.getElementById('vrinda-store-config');
  var cfg = {};
  if (cfgEl) {
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { /* noop */ }
  }
  var priv = cfg.privilege || {};
  var ENABLED = priv.enabled === true || priv.enabled === 'true';
  var THRESHOLD_INR = parseInt(priv.threshold_inr, 10) || 2499;
  var THRESHOLD_CENTS = THRESHOLD_INR * 100;
  var POOL_COLLECTION = priv.pool_collection || 'under-999';
  var GIFT_MAX_CENTS = 99900;
  var GIFT_MIN_CENTS = 69900;
  var GIFT_TAG = priv.gift_tag || 'Rakhi gift';
  var SKIP_BUYNOW = priv.skip_buynow === true || priv.skip_buynow === 'true';
  var FREE_LABEL = priv.free_label || 'FREE';

  if (!ENABLED) {
    var hidePrivilegePanels = function(){
      document.querySelectorAll('[data-privilege-panel]').forEach(function(el){ el.style.display='none'; el.innerHTML=''; });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hidePrivilegePanels);
    } else {
      hidePrivilegePanels();
    }
    return;
  }

  /* ── Pool products cache (5 min TTL, stock-aware) ─────────── */
  var _poolCache = null;
  var _poolCacheTime = 0;
  var _lastCartData = null;
  var _renderGeneration = 0;
  var _skipNextCartUpdate = false;
  function fetchPoolProducts(force) {
    var now = Date.now();
    if (_poolCache && !force && (now - _poolCacheTime) < 300000) return Promise.resolve(_poolCache);
    return fetch('/collections/' + POOL_COLLECTION + '/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var all = data.products || [];
        var eligible = [];
        for (var i = 0; i < all.length; i++) {
          var variants = all[i].variants || [];
          for (var j = 0; j < variants.length; j++) {
            var priceCents = Math.round(parseFloat(variants[j].price) * 100);
            if (priceCents >= GIFT_MIN_CENTS && priceCents <= GIFT_MAX_CENTS && variants[j].available) {
              eligible.push(all[i]);
              break;
            }
          }
        }
        _poolCache = eligible;
        _poolCacheTime = Date.now();
        return _poolCache;
      });
  }

  /* ── Helpers ─────────────────────────────────────────────────── */
  function fmtMoney(cents) {
    if (typeof cents !== 'number') return '₹0';
    var rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function imgSrc(url, w) {
    if (!url) return '';
    var src = url.trim();
    if (!src) return '';
    if (src.startsWith('//')) src = 'https:' + src;
    var width = w || 192;
    if (/cdn\.shopify\.com/i.test(src) && !/[?&]width=\d+/i.test(src)) {
      src += (src.includes('?') ? '&' : '?') + 'width=' + width;
    }
    return src;
  }

  function esc(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart fetch failed');
      return r.json();
    });
  }

  function addGift(variantId) {
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    body.append('properties[_vrinda_privilege]', 'gift-' + variantId);
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', body: body
    }).then(function (r) { return r.json(); });
  }

  function removeGift(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function findFirstPoolVariant(cartData) {
    var cartVariantIds = {};
    if (cartData && cartData.items) {
      for (var ci = 0; ci < cartData.items.length; ci++) {
        var cp = cartData.items[ci].properties || {};
        if (!cp._vrinda_privilege) cartVariantIds[cartData.items[ci].variant_id] = true;
      }
    }
    return fetch('/collections/' + POOL_COLLECTION + '/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        for (var i = 0; i < products.length; i++) {
          var variants = products[i].variants || [];
          for (var j = 0; j < variants.length; j++) {
            if (cartVariantIds[variants[j].id]) continue;
            var priceCents = Math.round(parseFloat(variants[j].price) * 100);
            if (priceCents >= GIFT_MIN_CENTS && priceCents <= GIFT_MAX_CENTS && variants[j].available) return variants[j];
          }
        }
        return null;
      });
  }

  function isPoolVariantId(variantId) {
    if (!_poolCache || !_poolCache.length) return false;
    for (var p = 0; p < _poolCache.length; p++) {
      var vs = _poolCache[p].variants || [];
      for (var vi = 0; vi < vs.length; vi++) if (vs[vi].id == variantId) return true;
    }
    return false;
  }
  function isPoolGiftItem(item) {
    // Paid Under ₹999 that became FREE via BXGY (Fastrr/Shopify) — no _vrinda_privilege but discounted to 0
    if (!item) return false;
    var props = item.properties || {};
    if (props._vrinda_privilege) return true;
    // Discounted to 0 and variant is from Under ₹999 pool
    if (item.final_line_price === 0 && item.original_line_price > 0 && isPoolVariantId(item.variant_id)) return true;
    // Fallback: has discount allocation for our offer
    if (item.discount_allocations && item.discount_allocations.length && item.final_line_price === 0) {
      // Check if its price was in 600-999 range (Under ₹999)
      var price = Math.round(parseFloat(item.price || 0) * 100);
      if (price >= 60000 && price <= 99900) return true;
    }
    return false;
  }
  function eligibleSubtotal(cartData) {
    var sum = 0;
    var items = cartData.items || [];
    for (var i = 0; i < items.length; i++) {
      if (!isPoolGiftItem(items[i])) {
        sum += items[i].final_line_price;
      }
    }
    return sum;
  }

  function findGiftLine(cartData) {
    var items = cartData.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isPoolGiftItem(items[i])) return items[i];
    }
    return null;
  }

  /* ── Subtotal overrides ────────────────────────────────────── */
  function updateSubtotals(cartData) {
    var elig = eligibleSubtotal(cartData);
    var gift = findGiftLine(cartData);

    // Drawer subtotal
    var drawerEl = document.getElementById('cart-drawer-subtotal');
    if (drawerEl) {
      var drawerDisplay = elig + (gift ? 0 : 0);
      drawerEl.textContent = fmtMoney(elig);
    }

    // Page total
    var pageEl = document.querySelector('.cart-page-total-value');
    if (pageEl) {
      pageEl.textContent = fmtMoney(elig);
    }

    // Shipping progress
    var shipEl = document.querySelector('[data-shipping-progress]');
    if (shipEl) {
      var threshold = parseInt(shipEl.getAttribute('data-threshold'), 10) || 99900;
      var remaining = threshold - elig;
      var progress = Math.min(100, Math.round((elig / threshold) * 100));
      var msgEl = shipEl.querySelector('.shipping-progress-msg');
      if (remaining <= 0) {
        msgEl.textContent = 'You unlocked free shipping';
        msgEl.className = 'shipping-progress-msg shipping-progress-msg--success';
      } else {
        msgEl.textContent = 'Add ' + fmtMoney(remaining) + ' more for free shipping';
        msgEl.className = 'shipping-progress-msg';
      }
      var fillEl = shipEl.querySelector('.shipping-progress-fill');
      if (fillEl) fillEl.style.setProperty('--progress', progress);
    }
  }

  /* ── Inject CSS to hide gift lines from main cart list ─────── */
  function injectGiftHideCSS() {
    if (document.getElementById('vrinda-privilege-gift-hide')) return;
    var s = document.createElement('style');
    s.id = 'vrinda-privilege-gift-hide';
    s.textContent = '[data-gift-line="true"]{display:none!important}';
    document.head.appendChild(s);
  }

  /* ── Gift line patching (MutationObserver) ─────────────────── */
  var PATCH_ATTR = 'data-privilege-patched';

  function patchGiftLines(root) {
    var targets = root.querySelectorAll
      ? root.querySelectorAll('[data-key]')
      : [];
    if (!targets.length && root.hasAttribute && root.hasAttribute('data-key')) {
      targets = [root];
    }
    // Filter to unpatched only — skip elements inside privilege panel (our own gift card)
    var toPatch = [];
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.hasAttribute(PATCH_ATTR) || el.hasAttribute('data-gift-line')) continue;
      if (el.closest && el.closest('[data-privilege-panel]')) continue;
      var key = el.getAttribute('data-key');
      if (key) toPatch.push({ el: el, key: key });
    }
    if (!toPatch.length) return;

    function applyMap(cartData) {
      var items = cartData.items || [];
      var keyMap = {};
      for (var j = 0; j < items.length; j++) keyMap[items[j].key] = items[j];
      for (var k = 0; k < toPatch.length; k++) {
        var entry = toPatch[k];
        var item = keyMap[entry.key];
        if (item && isPoolGiftItem(item)) {
          entry.el.setAttribute('data-gift-line', 'true');
          entry.el.setAttribute(PATCH_ATTR, '1');
        }
      }
    }
    // Use cached cart if available — synchronous, avoids flash duplication before fetch
    if (_lastCartData && _lastCartData.items) {
      applyMap(_lastCartData);
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applyMap);
  }

  /* ── Cart count patch (exclude gift lines) ──────────────────── */
  function patchCartCount(cartData) {
    function apply(cartData) {
      var items = cartData.items || [];
      var giftCount = 0;
      var totalPaid = 0;
      for (var i = 0; i < items.length; i++) {
        if (isPoolGiftItem(items[i])) {
          giftCount++;
        } else {
          totalPaid += items[i].quantity;
        }
      }
      if (!giftCount) return;

      // Patch numeric badge elements — set to totalPaid (not subtract from DOM)
      var countEls = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-badge, .cart-drawer-count');
      for (var c = 0; c < countEls.length; c++) {
        countEls[c].textContent = String(totalPaid);
      }

      // Patch drawer title "Your cart (N)" — use regex to replace the number
      var titleEl = document.querySelector('#CartDrawer-Title');
      if (titleEl && /\(\d+\)/.test(titleEl.textContent)) {
        titleEl.textContent = titleEl.textContent.replace(/\(\d+\)/, '(' + totalPaid + ')');
      }
    }
    if (cartData) {
      apply(cartData);
    } else {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(apply);
    }
  }

  /* ── Inject panel placeholders (when Liquid SSR guard skipped them) ── */
  function injectPanelPlaceholders() {
    // Check if panels are still in the DOM (cart rebuild destroys them)
    var existing = document.querySelectorAll('[data-privilege-panel]');
    var live = [];
    for (var ei = 0; ei < existing.length; ei++) {
      if (existing[ei].parentNode) live.push(existing[ei]);
    }
    if (live.length) return; // panels still present

    // Cart drawer: insert after .cart-lines-stack inside #cart-drawer
    var drawerStack = document.querySelector('#cart-drawer .cart-lines-stack');
    if (drawerStack) {
      var dp = document.createElement('div');
      dp.setAttribute('data-privilege-panel', '');
      dp.setAttribute('aria-live', 'polite');
      dp.className = 'privilege-panel';
      drawerStack.parentNode.insertBefore(dp, drawerStack.nextSibling);
    }

    // Main cart: insert after last .cart-line inside #cart-form
    var cartForm = document.getElementById('cart-form');
    if (cartForm) {
      var lines = cartForm.querySelectorAll('.cart-line');
      if (lines.length) {
        var last = lines[lines.length - 1];
        var mp = document.createElement('div');
        mp.setAttribute('data-privilege-panel', '');
        mp.setAttribute('aria-live', 'polite');
        mp.className = 'privilege-panel';
        last.parentNode.insertBefore(mp, last.nextSibling);
      }
    }
  }

  /* ── Panel render (client-side rebuild) ─────────────────────── */
  function renderPanel(cartData) {
    var myGen = _renderGeneration;
    injectPanelPlaceholders();
    var panels = document.querySelectorAll('[data-privilege-panel]');
    if (!panels.length || !priv) return;

    var items = cartData.items || [];
    if (!items.length) {
      for (var p = 0; p < panels.length; p++) panels[p].innerHTML = '';
      return;
    }

    var gift = findGiftLine(cartData);
    var elig = eligibleSubtotal(cartData);
    var below = elig < THRESHOLD_CENTS;
    var cartVariantIds = {};
    for (var cci = 0; cci < items.length; cci++) {
      var cprops = items[cci].properties || {};
      if (!cprops._vrinda_privilege) cartVariantIds[items[cci].variant_id] = true;
    }
    try { console.log('[Vrinda Privilege] render gen=' + _renderGeneration, { items: items.length, elig: elig, below: below, gift: gift ? (gift.product_title + ' key=' + gift.key) : null, pool: _poolCache ? _poolCache.length : null }); } catch(e){}

    // If unlocked and no gift, need pool products — fetch if not cached
    if (!below && !gift && !_poolCache) {
      var loadingHtml = '<p class="privilege-panel-heading">' + esc(priv.unlocked_heading || 'Choose your Rakhi gift') + '</p><p class="privilege-panel-status">Loading gifts…</p>';
      for (var lp = 0; lp < panels.length; lp++) panels[lp].innerHTML = loadingHtml;
      fetchPoolProducts().then(function () {
        // Re-fetch cart to ensure we still need State 2 (gift may have been added while loading)
        fetchCart().then(function (fresh) { _lastCartData = fresh; if (myGen === _renderGeneration) renderPanel(fresh); }).catch(function(){ if (myGen === _renderGeneration) renderPanel(cartData); });
      }).catch(function(){
        for (var fp = 0; fp < panels.length; fp++) panels[fp].innerHTML = '<p class="privilege-panel-heading">' + esc(priv.unlocked_heading || 'Choose your Rakhi gift') + '</p><p class="privilege-panel-status">Could not load gifts — refresh page</p>';
      });
      return;
    }

    var h = '';
    if (below) {
      var rem = THRESHOLD_INR - Math.round(elig / 100);
      h += '<p class="privilege-panel-heading">' + esc(priv.locked_heading || "You're almost there") + ' — add ₹' + rem.toLocaleString('en-IN') + ' more</p>';
    } else if (!gift) {
      h += '<p class="privilege-panel-heading">' + esc(priv.unlocked_heading || 'Choose your Rakhi gift') + '</p>';
      h += '<div class="privilege-panel-grid" data-privilege-grid>';
      if (_poolCache) {
        var renderedCards = 0;
        for (var pi = 0; pi < _poolCache.length; pi++) {
          var prod = _poolCache[pi];
          var variants = prod.variants || [];
          for (var vi = 0; vi < variants.length; vi++) {
            var v = variants[vi];
            if (cartVariantIds[v.id]) continue;
            if (v.available) {
              var img = v.image && v.image.src ? v.image.src : (prod.images && prod.images[0] ? prod.images[0].src : '');
              h += '<div class="privilege-panel-card" data-privilege-add data-variant-id="' + v.id + '">';
              h += '<div class="privilege-panel-card-img"><img src="' + imgSrc(img, 192) + '" alt="' + esc(prod.title) + '" loading="lazy" width="152" height="152"></div>';
              h += '<div class="privilege-panel-card-body">';
              h += '<p class="privilege-panel-card-title">' + esc(prod.title) + '</p>';
              h += '<p class="privilege-panel-card-price"><span class="privilege-price-free">' + esc(priv.free_label || FREE_LABEL) + '</span></p>';
              h += '<button type="button" class="privilege-panel-card-select" data-privilege-select aria-label="Add ' + esc(prod.title) + ' as free gift">Select</button>';
              h += '</div></div>';
              renderedCards++;
              break;
            }
          }
        }
        if (!renderedCards) {
          if (!_poolCache || !_poolCache.length) {
            h += '<p class="privilege-panel-status">All gifts currently out of stock — please check back soon</p>';
          } else {
            h += '<p class="privilege-panel-status">All eligible gifts already in your bag — add a different product to unlock more</p>';
          }
        }
      }
      h += '</div>';
      h += '<p class="privilege-panel-status" data-privilege-status></p>';
    } else {
      var gImg = (gift.featured_image && gift.featured_image.url) || (typeof gift.image === 'string' ? gift.image : (gift.image && gift.image.src ? gift.image.src : ''));
      var gUrl = gift.url || '#';
      var gVariantTitle = gift.variant_title || '';
      h += '<p class="privilege-panel-heading">' + esc(priv.added_heading || 'Your Rakhi gift') + '</p>';
      h += '<div class="privilege-panel-added">';
      h += '<div class="cart-line cart-line--drawer cart-line--gift" data-key="' + esc(gift.key || '') + '" data-variant-id="' + (gift.variant_id || '') + '">';
      if (gImg) {
        h += '<a class="cart-line-image" href="' + esc(gUrl) + '"><img src="' + imgSrc(gImg, 160) + '" alt="' + esc(gift.product_title) + '" loading="lazy" width="88" height="88"></a>';
      }
      h += '<div class="cart-line-body">';
      h += '<a class="cart-line-title" href="' + esc(gUrl) + '">' + esc(gift.product_title) + '</a>';
      if (gVariantTitle && gVariantTitle !== 'Default Title') {
        h += '<p class="cart-line-variant">' + esc(gVariantTitle) + '</p>';
      }
      h += '<p class="cart-line-price"><span class="privilege-price-free">' + esc(priv.free_label || FREE_LABEL) + '</span> <s class="privilege-price-original">' + fmtMoney(gift.original_line_price) + '</s> <span class="privilege-panel-added-tag">' + esc(priv.gift_tag || GIFT_TAG) + '</span></p>';
      h += '<div class="cart-line-controls cart-line--gift-controls">';
      h += '<button type="button" class="cart-line-swap" data-privilege-swap aria-label="Swap gift">' + esc(priv.swap_label || 'Swap gift') + '</button>';
      h += '<button type="button" class="cart-remove-btn" data-privilege-remove aria-label="Remove gift"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      h += '</div></div></div>';
      if (_poolCache) {
        h += '<div class="privilege-panel-swap-grid" data-privilege-swap-grid hidden>';
        h += '<p class="privilege-panel-swap-heading">Choose a different gift</p>';
        h += '<div class="privilege-panel-grid">';
        for (var pi2 = 0; pi2 < _poolCache.length; pi2++) {
          var prod2 = _poolCache[pi2];
          var vs2 = prod2.variants || [];
          for (var vi2 = 0; vi2 < vs2.length; vi2++) {
            var v2 = vs2[vi2];
            if (cartVariantIds[v2.id]) continue;
            if (v2.available) {
              var img2 = v2.image && v2.image.src ? v2.image.src : (prod2.images && prod2.images[0] ? prod2.images[0].src : '');
              h += '<div class="privilege-panel-card" data-privilege-add data-variant-id="' + v2.id + '">';
              h += '<div class="privilege-panel-card-img"><img src="' + imgSrc(img2, 192) + '" alt="' + esc(prod2.title) + '" loading="lazy" width="152" height="152"></div>';
              h += '<div class="privilege-panel-card-body">';
              h += '<p class="privilege-panel-card-title">' + esc(prod2.title) + '</p>';
              h += '<p class="privilege-panel-card-price"><span class="privilege-price-free">' + esc(priv.free_label || FREE_LABEL) + '</span></p>';
              h += '<button type="button" class="privilege-panel-card-select" data-privilege-select aria-label="Swap to ' + esc(prod2.title) + '">Select</button>';
              h += '</div></div>';
              break;
            }
          }
        }
        h += '</div>';
        h += '<button type="button" class="privilege-btn privilege-btn--cancel" data-privilege-swap-cancel>Cancel</button>';
        h += '</div>';
      }
      h += '</div>';
    }

    // Render into ALL panels (main cart + drawer)
    for (var pi3 = 0; pi3 < panels.length; pi3++) {
      var panel = panels[pi3];
      panel.innerHTML = h;

      // Re-attach swap grid toggle (inline, no delegation needed for swap/cancel)
      var swapBtn = panel.querySelector('[data-privilege-swap]');
      if (swapBtn) {
        swapBtn.addEventListener('click', (function (p) {
          return function (e) {
            e.preventDefault();
            var sg = p.querySelector('[data-privilege-swap-grid]');
            if (sg) sg.hidden = false;
          };
        })(panel));
      }
      var cancelBtn = panel.querySelector('[data-privilege-swap-cancel]');
      if (cancelBtn) {
        cancelBtn.addEventListener('click', (function (p) {
          return function (e) {
            e.preventDefault();
            var sg2 = p.querySelector('[data-privilege-swap-grid]');
            if (sg2) sg2.hidden = true;
          };
        })(panel));
      }
    }
  }

  /* ── Toast ──────────────────────────────────────────────────── */
  var toastEl = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.getElementById('vrinda-toast');
    }
    if (toastEl) {
      toastEl.textContent = msg;
      toastEl.classList.add('is-visible');
      clearTimeout(toastEl._timer);
      toastEl._timer = setTimeout(function () {
        toastEl.classList.remove('is-visible');
      }, 3000);
    }
  }

  /* ── Panel event delegation ────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var selectBtn = e.target.closest('[data-privilege-select]');
    var addCard = e.target.closest('[data-privilege-add]');
    if (selectBtn && addCard) {
      e.preventDefault();
      var variantId = addCard.getAttribute('data-variant-id');
      if (!variantId) return;
      _renderGeneration++;
      selectBtn.disabled = true;
      selectBtn.textContent = 'Adding…';

      fetchCart().then(function (cartData) {
        var gift = findGiftLine(cartData);
        if (gift) {
          // Remove existing gift first, then add new
          return removeGift(gift.key).then(function () {
            return addGift(variantId);
          });
        }
        return addGift(variantId);
      }).then(function () {
        showToast('Gift added to your bag');
        // Show temp confirmation, then full reload (panel re-renders to State 3)
        // Shopify /cart.js can lag ~300ms behind /cart/add.js — wait 650ms
        selectBtn.textContent = 'Added ✓';
        setTimeout(function () { reloadDrawer(); }, 650);
      }).catch(function () {
        showToast('Could not add gift — try again');
        selectBtn.disabled = false;
        selectBtn.textContent = 'Select';
      });
    }

    var removeBtn = e.target.closest('[data-privilege-remove]');
    if (removeBtn) {
      e.preventDefault();
      _renderGeneration++;
      fetchCart().then(function (cartData) {
        var gift = findGiftLine(cartData);
        if (gift) return removeGift(gift.key);
      }).then(function () {
        showToast('Gift removed');
        reloadDrawer();
      }).catch(function () {
        showToast('Could not remove gift — try again');
      });
    }
  });

  /* ── Reload drawer content ─────────────────────────────────── */
  function reloadDrawer() {
    _renderGeneration++;
    fetchCart().then(function (cartData) {
      _lastCartData = cartData;
      updateSubtotals(cartData);
      patchCartCount(cartData);

      // The gift we just added is in cartData. Render panel immediately so
      // user sees State 3 for a beat — then let VrindaCart.refresh rebuild
      // drawer lines and our cart:updated listener will re-render from fresh fetch.
      renderPanel(cartData);
      patchGiftLines(document);

      if (window.VrindaCart && typeof window.VrindaCart.refresh === 'function') {
        try {
          _skipNextCartUpdate = true;
          var refreshed = window.VrindaCart.refresh(cartData);
          // VrindaCart.refresh rebuilds .cart-lines-stack via innerHTML synchronously.
          // patchGiftLines via MutationObserver is async (microtask) → flashes gift as regular ₹600 line.
          // Hide synchronously before paint + double-patch on next frame to kill flash.
          patchGiftLines(document);
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(function(){ patchGiftLines(document); });
          }
          setTimeout(function(){ patchGiftLines(document); }, 80);
          if (refreshed && typeof refreshed.then === 'function') {
            refreshed.then(function(){ patchGiftLines(document); }).catch(function () { /* noop */ });
          }
        } catch (e) { /* noop */ }
        return;
      }

      // Fallback: no VrindaCart available — try MutationObserver + custom event
      var stack = document.querySelector('.cart-lines-stack');
      if (stack) {
        var mo = new MutationObserver(function () {
          mo.disconnect();
          renderPanel(cartData);
          patchGiftLines(document);
        });
        mo.observe(stack, { childList: true, subtree: true });
        setTimeout(function () { renderPanel(cartData); patchGiftLines(document); }, 350);
      } else {
        renderPanel(cartData);
        patchGiftLines(document);
      }
      if (typeof window !== 'undefined' && window.CustomEvent) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }).catch(function () {
      if (window.VrindaCart && typeof window.VrindaCart.refresh === 'function') {
        try { window.VrindaCart.refresh(); } catch (e) { /* noop */ }
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  }

  /* ── Fastrr/Shiprocket checkout guard ──────────────────────── */
  function wrapCheckout() {
    var SKIP_KEY = 'vrinda_privilege_skip';
    var SKIP_MS = 120000;

    function guard(cartData) {
      var gift = findGiftLine(cartData);
      var elig = eligibleSubtotal(cartData);
      var skipUntil = 0;
      try { skipUntil = parseInt(sessionStorage.getItem(SKIP_KEY), 10) || 0; } catch (e) { /* noop */ }
      var skipActive = Date.now() < skipUntil;

      // Below threshold → remove gift
      if (elig < THRESHOLD_CENTS) {
        if (gift) {
          return removeGift(gift.key).then(function () {
            showToast('Gift removed — below ₹' + THRESHOLD_INR + ' threshold');
            return { removed: true };
          });
        }
        return Promise.resolve({ ok: true });
      }

      // Offer inactive (if dates set) & has gift → remove
      if (priv.start_date && priv.end_date) {
        var now = new Date();
        var start = new Date(priv.start_date);
        var end = new Date(priv.end_date);
        end.setHours(23, 59, 59, 999);
        if (now < start || now > end) {
          if (gift) {
            return removeGift(gift.key).then(function () {
              showToast('Offer period ended — gift removed');
              return { removed: true };
            });
          }
          return Promise.resolve({ ok: true });
        }
      }

      // Eligible & gift present but NOT FREE (BXG didn't apply) → remove first
      if (gift && gift.final_line_price > 0) {
        return removeGift(gift.key).then(function () {
          return fetchCart();
        }).then(function (cd) {
          // After removal, try to add fresh gift
          return addFirstPoolItem(cd);
        });
      }

      // Eligible & no gift → auto-add first in-stock pool item (unless skip flag)
      if (!gift && !skipActive) {
        return addFirstPoolItem(cartData);
      }

      return Promise.resolve({ ok: true });
    }

    function addFirstPoolItem(cartData) {
      if (SKIP_BUYNOW) return Promise.resolve({ ok: true });
      return findFirstPoolVariant(cartData).then(function (variant) {
        if (variant) {
          return addGift(variant.id).then(function () {
            showToast('Free gift added to your bag');
            return { added: true };
          });
        }
        return { ok: true };
      });
    }

    function runGuardAndCheckout(originalFn, args) {
      var cartPromise = (_lastCartData && _lastCartData.items) ? Promise.resolve(_lastCartData) : fetchCart();
      cartPromise.then(function (cartData) {
        return guard(cartData).then(function (result) {
          if (result && result.removed) {
            reloadDrawer();
            return;
          }
          if (typeof originalFn === 'function') {
            originalFn.apply(null, args || []);
          }
        });
      }).catch(function () {
        if (typeof originalFn === 'function') {
          originalFn.apply(null, args || []);
        }
      });
    }

    // Wrap shiprocketCheckoutEvents
    if (typeof window.shiprocketCheckoutEvents !== 'undefined') {
      var origBuyCart = window.shiprocketCheckoutEvents.buyCart;
      var origBuyProduct = window.shiprocketCheckoutEvents.buyProduct;
      window.shiprocketCheckoutEvents.buyCart = function () {
        runGuardAndCheckout(origBuyCart, arguments);
      };
      window.shiprocketCheckoutEvents.buyProduct = function () {
        runGuardAndCheckout(origBuyProduct, arguments);
      };
    }

    // Wrap Fastrr?.Checkout?.open
    if (typeof window.Fastrr !== 'undefined' && window.Fastrr.Checkout) {
      var origOpen = window.Fastrr.Checkout.open;
      window.Fastrr.Checkout.open = function () {
        runGuardAndCheckout(origOpen, arguments);
      };
    }

    // Wrap ShiprocketCheckout?.open
    if (typeof window.ShiprocketCheckout !== 'undefined') {
      var origSR = window.ShiprocketCheckout.open;
      window.ShiprocketCheckout.open = function () {
        runGuardAndCheckout(origSR, arguments);
      };
    }

    // Wrap global openShiprocketCheckout
    if (typeof window.openShiprocketCheckout === 'function') {
      var origGlobal = window.openShiprocketCheckout;
      window.openShiprocketCheckout = function () {
        runGuardAndCheckout(origGlobal, arguments);
      };
    }

  }

  /* ── Buy-Now guard ─────────────────────────────────────────── */
  function guardBuyNow() {
    document.addEventListener('click', function (e) {
      var buyNowBtn = e.target.closest('[name="buy-now"], .buy-now-btn, [data-buy-now]');
      if (!buyNowBtn) return;

      fetchCart().then(function (cartData) {
        var gift = findGiftLine(cartData);
        var elig = eligibleSubtotal(cartData);

        if (elig >= THRESHOLD_CENTS && !gift) {
          e.preventDefault();
          e.stopPropagation();
          addFirstPoolItem(cartData).then(function () {
            showToast('Free gift added — redirecting to checkout');
            // Re-trigger the buy now button after a short delay
            setTimeout(function () { buyNowBtn.click(); }, 500);
          });
        }
        // If below threshold or gift already present, let it proceed normally
      }).catch(function () { /* let it proceed on error */ });
    }, true);
  }

  /* ── Init ───────────────────────────────────────────────────── */
  function init() {
    // Inject CSS to hide gift lines from main cart list
    injectGiftHideCSS();

    // Fetch pool products first, then cart + render panel
    fetchPoolProducts().then(function () {
      return fetchCart();
    }).then(function (cartData) {
      _lastCartData = cartData;
      updateSubtotals(cartData);
      renderPanel(cartData);
      patchGiftLines(document);
      patchCartCount(cartData);
    }).catch(function () { /* noop */ });

    // Observe cart changes for gift line patching + count patching
    // NOTE: panel re-render on stack rebuild is now handled solely by the
    // cart:updated listener (which fetches fresh /cart.js). The old
    // panelGone → renderPanel(_lastCartData) path caused flash-then-empty
    // because _lastCartData was stale when VrindaCart.refresh wiped the panel.
    var observer = new MutationObserver(function (mutations) {
      var needsGiftPatch = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            patchGiftLines(added[j]);
            needsGiftPatch = true;
          }
        }
      }
      if (needsGiftPatch) patchCartCount();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Patch existing gift lines
    patchGiftLines(document);

    // Wrap checkout
    wrapCheckout();

    // Guard Buy-Now
    guardBuyNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-fetch subtotals + re-render panel on cart update events
  // (vrinda-v2.js rebuilds DOM on these events, wiping our JS-rendered panel)
  // Spec §8: if cart drops below ₹2,499, auto-remove gift immediately (shopify way)
  document.addEventListener('cart:updated', function () {
    if (_skipNextCartUpdate) { _skipNextCartUpdate = false; try { console.log('[Vrinda Privilege] skipped stale cart:updated'); } catch(e){} return; }
    var gen = _renderGeneration;
    fetchCart().then(function (cd) {
      if (gen !== _renderGeneration) { try { console.log('[Vrinda Privilege] stale render rejected gen=' + gen + ' current=' + _renderGeneration); } catch(e){} return; }
      _lastCartData = cd;
      var giftChk = findGiftLine(cd);
      var eligChk = eligibleSubtotal(cd);
      if (giftChk && eligChk < THRESHOLD_CENTS) {
        removeGift(giftChk.key).then(function () {
          showToast('Gift removed — below ₹' + THRESHOLD_INR + ' threshold');
          reloadDrawer();
        }).catch(function () {
          updateSubtotals(cd);
          renderPanel(cd);
          patchGiftLines(document);
        });
        return;
      }
      updateSubtotals(cd);
      renderPanel(cd);
      patchGiftLines(document);
      patchCartCount(cd);
    }).catch(function () { /* noop */ });
  });
  document.addEventListener('cart:refresh', function () {
    var gen = _renderGeneration;
    fetchCart().then(function (cd) {
      if (gen !== _renderGeneration) return;
      _lastCartData = cd;
      var giftChk2 = findGiftLine(cd);
      var eligChk2 = eligibleSubtotal(cd);
      if (giftChk2 && eligChk2 < THRESHOLD_CENTS) {
        removeGift(giftChk2.key).then(function () {
          showToast('Gift removed — below ₹' + THRESHOLD_INR + ' threshold');
          reloadDrawer();
        }).catch(function () {
          updateSubtotals(cd);
          renderPanel(cd);
          patchGiftLines(document);
        });
        return;
      }
      _lastCartData = cd;
      updateSubtotals(cd);
      renderPanel(cd);
      patchGiftLines(document);
      patchCartCount(cd);
    }).catch(function () { /* noop */ });
  });
})();